module.exports = __webpack_public_path__ + "static/img/yn-bio.6fae6a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile/case/yn-bio.jpg
// module id = wTTz
// module chunks = 1